import { get } from "lodash"
import { SelectedExperiment } from "helpers/types/instruments/selected"
import { IsoDate } from "helpers/types/dates"
import { OkReduxDataResult } from "model/state"
import { CompositionByNode, getCompositionType } from "./composition"
import { PositionSetMetadata } from "./types"

interface ExperimentData {
  portfolio: {
    experiment: {
      name: string
      availableFrom: IsoDate
    }
  }
  model: {
    simulation: {
      composition: [{
        referenceEquity: number
        compositionBy: CompositionByNode
      }]
    }
  }
}

export interface ExperimentMetadata extends PositionSetMetadata {
  type: "EXPERIMENT"
}

const PORTFOLIO_EXPERIMENT_QUERY = `query ($portfolioId: String!, $modelId: String!, $currentDate: Date!, $segment: Segment, $experimentId: String!) {
  portfolio (id: $portfolioId) {
    experiment(id: $experimentId) {
      name
      availableFrom
    }
  }
  model (id: $modelId) {
    simulation (positionSet: {
      type: PORTFOLIO,
      id: $portfolioId,
      experimentId: $experimentId,
      segment: $segment
    }, from: $currentDate, to: $currentDate) {
      composition {
        compositionBy (groupBy: LONG_SHORT) {
          id
        }
      }
    }
  }
}`

function portfolioExperimentSelect(data: OkReduxDataResult<ExperimentData>, metadataDate: IsoDate): ExperimentMetadata {
  return {
    type: "EXPERIMENT",
    unavailable: false,
    name: get(data, "data.portfolio.experiment.name"),
    earliestDate: get(data, "data.portfolio.experiment.availableFrom"),
    compositionType: getCompositionType(data),
    latestDate: metadataDate,
  }
}

export function getExperimentQueryDefinition(positionSet: SelectedExperiment, modelId: string, metadataDate: IsoDate) {
  const variables = { portfolioId: positionSet.id, experimentId: positionSet.experimentId, modelId, currentDate: metadataDate, segment: positionSet.segment }
  return {
    query: PORTFOLIO_EXPERIMENT_QUERY,
    variables,
    queryKey: ["position-set", "metadata", "portfolio-experiment", variables],
    select: (data: OkReduxDataResult<ExperimentData>) => portfolioExperimentSelect(data, metadataDate),
  }
}
